import React from 'react'
import styleAbout from './CSS/styleAbout.css'
export default function About() {
    return (
        <div>
            
  <header>
    <h1 class="heading__blogs">All About PCOS</h1>
  </header>
  <main>
    <section id="card__container">
      <div class="sectionCards">
        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://images.unsplash.com/photo-1513866717996-6c19fd870937?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8d29tYW4lMjB1bWJyZWxsYXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Overview</h5>
              <p class="card-text">Polycystic Ovarian Syndrome (PCOS) is a common endocrine system disorder affecting about 12-18% of women in the reproductive age.
                content.</p>
              <a href="/about_overview" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://media.istockphoto.com/photos/young-redhead-teenager-with-self-issues-looking-into-mirror-girl-with-picture-id903214374?b=1&k=20&m=903214374&s=170667a&w=0&h=gu0HNgiZ03kfzhBxJkBluR5ZpnFJvlKI9MQFjhFjw58="
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Cosmetic Issues</h5>
              <p class="card-text">Hyperandrogenism (excess male hormone) in PCOS often manifests itself with the cosmetically disfiguring problems of acne.hirsutism, hair loss.
                </p>
              <a href="/about_cosmetic" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://media.istockphoto.com/photos/anxious-arabic-woman-feel-unhappy-thinking-at-home-picture-id1267716518?b=1&k=20&m=1267716518&s=170667a&w=0&h=uU5ZZVI3lTEB0Z4TzNtDnztPwiUdrCvbspkSix-vUn4=" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Irregular Periods</h5>
              <p class="card-text">Polycystic ovary syndrome signs and symptoms often begin soon after a woman first begins having periods (menarche) symptoms often begin soon afte.
                content.</p>
              <a href="/about_irregularPeriod" class="myButton">Read More</a>
            </div>
          </div>
        </div>
      </div>

      <div class="sectionCards">
        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsunJdn1HXTx2Nco3El-J1CDHgDwZmIFZP6g&usqp=CAU"
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Infertility</h5>
              <p class="card-text">PCOS, is a common cause of anovulation and female infertility. Anovulation occurs when the ovaries do not release an egg during menstruation.
                content.</p>
              <a href="/about_infertility" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbDZ89fwDyJax5_bNT5O7Wk1gydNdG6gCAEw&usqp=CAU" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Early and Recurrent Pregnancy Loss</h5>
              <p class="card-text">The reproductive issues with PCOS are manifold starting with anovulatory cycles leading to subfertility.
                content.</p>
              <a href="/about_pregLoss" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9K1ZUAa4_9N9ik3F7O1Aqy5ESI7MQXLjBcA&usqp=CAU"
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Gestational Diabetes</h5>
              <p class="card-text">Women with PCOS have an increased risk of developing Gestational Diabetes Mellitus, regardless if they are overweight or not.
                content.</p>
              <a href="/about_gesDiabeates" class="myButton">Read More</a>
            </div>
          </div>
        </div>
      </div>

      <div class="sectionCards">
        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrUm6Ms0NVHjxesnSmve_xXuSFuHLqz1ps6Q&usqp=CAU" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Risk For Chronic Diabetes</h5>
              <p class="card-text">The earlier your PCOS is diagnosed and treated, the lower your risk of developing complications associated with PCOS.</p>
              <a href="/about_chronicDiabeates" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1DoLfPDrc_qwW_z1XDn_Qy2hJA_EPNMKLKw&usqp=CAU"
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">Nutrition and PCOS</h5>
              <p class="card-text">Most women relate PCOS to being overweight or obese. This is a common misconception but the fact is that up to 50% of women diagnosed with…
                </p>
              <a href="/about_nutrition" class="myButton">Read More</a>
            </div>
          </div>
        </div>

        <div class="cards">
          <div class="card" style={{width:"18rem"}}>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLJggYfZSmJ3R2fNCrhvk_dDUedmelR672Lw&usqp=CAU"
              class="card-img-top" alt="..."/>
            <div class="card-body">
              <h5 class="card-title">System Management</h5>
              <p class="card-text">We have read about in detail about PCOS Symptoms and treatment in these pages. Let’s now look at how PCOS affects Mental...
              </p>
              <a href="/about_sm" class="myButton">Read More</a>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>
  
        </div>
    )
}
